/**
 * The rough layer's box geometry, read from the one owner the
 * span cells use: the lane numbers `CalendarColumnLayoutGroup` plans for each
 * entry (`PlanEntry.lane`, from which it renders the cell's lane style), and
 * `PIXELS_PER_HOUR`. Nothing here restates a lane number or parses the CSS
 * the group writes.
 */

import { CalendarColumnLayoutGroup } from "@tento-ui/components/calendar/calendar-column-layout-group";
import { PIXELS_PER_HOUR } from "@tento-ui/components/calendar/calendar-hour";
import type { RoughBox, RoughBoxes } from "./calendar-rough-layer.ts";

/** Box rects from plan entries (pure). */
export namespace RoughGeometry {
  /**
   * The rect a span cell takes, read from its plan entry's lane numbers (the
   * x offset as `fraction·G + px` of the group's width, the end inset, the
   * extra height and the top margin) under the cell's CSS (`left` = x
   * offset, `width: 100% - x offset - end inset`, height `PIXELS_PER_HOUR`
   * per hour plus the extra height), placed at `slot`, `top` px down the
   * layer. Every planned entry has a box.
   */
  export function cellBox(entry: CalendarColumnLayoutGroup.PlanEntry, slot: RoughBoxes.Slot, top: number): RoughBox {
    const { lane } = entry;
    const offset = CalendarColumnLayoutGroup.Lane.offsetLength(lane.xOffset);
    return {
      id: entry.id,
      gx: slot.left + slot.width * offset.fraction,
      bx: offset.px,
      fw: slot.width * (1 - offset.fraction),
      aw: -offset.px - lane.endInsetPx,
      y: top + PIXELS_PER_HOUR * entry.startMs / 3_600_000 + lane.marginTopPx,
      height: PIXELS_PER_HOUR * (entry.endMs - entry.startMs) / 3_600_000 + lane.additionalHeightPx,
    };
  }
}
